const loadingLabel = "Cargando";
const esMX = {
  loadingLabel
};
export {
  esMX as default,
  loadingLabel
};
